module.exports = __webpack_public_path__ + "static/img/WF-1000XM3.c474b96b.jpg";